/*
  SIZMARI STUDIO — artwork photo zoom.
  Click / tap a photo on an artwork page -> full-screen view on white.
  In the full-screen view:
    - click / tap the photo (or press +/−, Z) to zoom in on that spot, again to zoom out;
    - when zoomed: move the mouse to look around (desktop), drag with a finger (phones);
    - phones can also pinch;
    - ← / → or the arrows switch photos, Esc or "Close" closes.
  Loaded only on product pages (see snippets/sizmari-header.liquid).
*/
(function () {
  'use strict';
  if (window.__szZoom) return;
  window.__szZoom = true;

  var ZOOM = 2.5;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

  function biggestSrc(img) {
    var best = img.currentSrc || img.src;
    var bestW = 0;
    (img.getAttribute('srcset') || '').split(',').forEach(function (part) {
      var bits = part.trim().split(/\s+/);
      var w = parseInt(bits[1], 10);
      if (bits[0] && w > bestW) { bestW = w; best = bits[0]; }
    });
    // Ask the Shopify CDN for a larger file (it never upscales past the original)
    if (/[?&]width=\d+/.test(best)) best = best.replace(/([?&]width=)\d+/, '$14000');
    return best;
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html) n.innerHTML = html;
    return n;
  }

  var hint, box, stage, pic, counter, btnPrev, btnNext, btnClose, list = [], index = 0, zoomed = false, lastFocus = null;

  function build() {
    box = el('div', 'szz');
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Photo');
    box.hidden = true;

    stage = el('div', 'szz__stage');
    pic = el('img', 'szz__img');
    pic.alt = '';
    pic.draggable = false;
    stage.appendChild(pic);

    var bar = el('div', 'szz__bar');
    counter = el('span', 'szz__count');
    counter.setAttribute('aria-live', 'polite');
    hint = el('span', 'szz__hint', '');
    btnClose = el('button', 'szz__btn szz__close', 'Close <span aria-hidden="true">&times;</span>');
    btnClose.type = 'button';
    bar.appendChild(counter);
    bar.appendChild(hint);
    bar.appendChild(btnClose);

    btnPrev = el('button', 'szz__btn szz__nav szz__prev', '<span aria-hidden="true">&larr;</span>');
    btnPrev.type = 'button';
    btnPrev.setAttribute('aria-label', 'Previous photo');
    btnNext = el('button', 'szz__btn szz__nav szz__next', '<span aria-hidden="true">&rarr;</span>');
    btnNext.type = 'button';
    btnNext.setAttribute('aria-label', 'Next photo');

    box.appendChild(stage);
    box.appendChild(bar);
    box.appendChild(btnPrev);
    box.appendChild(btnNext);
    document.body.appendChild(box);


    btnClose.addEventListener('click', close);
    btnPrev.addEventListener('click', function () { go(-1); });
    btnNext.addEventListener('click', function () { go(1); });

    pic.addEventListener('click', function (e) { toggleZoom(e.clientX, e.clientY); });

    stage.addEventListener('mousemove', function (e) {
      if (!zoomed || !fine.matches) return;
      var r = stage.getBoundingClientRect();
      var fx = (e.clientX - r.left) / r.width;
      var fy = (e.clientY - r.top) / r.height;
      stage.scrollLeft = fx * (stage.scrollWidth - stage.clientWidth);
      stage.scrollTop = fy * (stage.scrollHeight - stage.clientHeight);
    });

    // Click on the empty white area closes (only when not zoomed)
    stage.addEventListener('click', function (e) {
      if (e.target === stage && !zoomed) close();
    });

    document.addEventListener('keydown', function (e) {
      if (!box || box.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'z' || e.key === 'Z' || e.key === '+' || e.key === '-') {
        e.preventDefault();
        var r = stage.getBoundingClientRect();
        toggleZoom(r.left + r.width / 2, r.top + r.height / 2);
      } else if (e.key === 'Tab') {
        var f = [btnClose, btnPrev, btnNext].filter(function (b) { return !b.hidden; });
        var i = f.indexOf(document.activeElement);
        e.preventDefault();
        var next = e.shiftKey ? (i <= 0 ? f.length - 1 : i - 1) : (i + 1) % f.length;
        f[next].focus();
      }
    });
  }

  function fitSize() {
    var w = pic.naturalWidth || 1, h = pic.naturalHeight || 1;
    var sw = stage.clientWidth, sh = stage.clientHeight;
    var s = Math.min(sw / w, sh / h, 1.5);
    return { w: w * s, h: h * s };
  }

  function setHint() {
    var verb = fine.matches ? 'Click' : 'Tap';
    hint.textContent = zoomed ? verb + ' to zoom out' : verb + ' to zoom in';
  }

  function setFit() {
    zoomed = false;
    if (hint) setHint();
    box.classList.remove('is-zoomed');
    pic.style.width = '';
    pic.style.height = '';
    stage.scrollLeft = 0;
    stage.scrollTop = 0;
  }

  function toggleZoom(cx, cy) {
    if (zoomed) { setFit(); return; }
    var before = pic.getBoundingClientRect();
    var fx = before.width ? (cx - before.left) / before.width : 0.5;
    var fy = before.height ? (cy - before.top) / before.height : 0.5;
    fx = Math.min(Math.max(fx, 0), 1);
    fy = Math.min(Math.max(fy, 0), 1);
    var fit = fitSize();
    zoomed = true;
    setHint();
    box.classList.add('is-zoomed');
    pic.style.width = Math.round(fit.w * ZOOM) + 'px';
    pic.style.height = Math.round(fit.h * ZOOM) + 'px';
    // Keep the clicked spot under the pointer
    stage.scrollLeft = fx * stage.scrollWidth - (cx - stage.getBoundingClientRect().left);
    stage.scrollTop = fy * stage.scrollHeight - (cy - stage.getBoundingClientRect().top);
  }

  function show(i) {
    index = (i + list.length) % list.length;
    setFit();
    var src = list[index];
    pic.classList.add('is-loading');
    pic.onload = function () { pic.classList.remove('is-loading'); };
    pic.src = src.small;
    // swap to the large file once it has arrived
    var big = new Image();
    big.onload = function () { if (list[index] === src) { pic.src = src.big; pic.classList.remove('is-loading'); } };
    big.src = src.big;
    pic.alt = src.alt || '';
    var n = function (x) { return (x < 10 ? '0' : '') + x; };
    counter.textContent = n(index + 1) + ' / ' + n(list.length);
    btnPrev.hidden = btnNext.hidden = list.length < 2;
  }

  function go(step) {
    if (list.length > 1) show(index + step);
  }

  function open(images, start) {
    if (!box) build();
    list = images;
    lastFocus = document.activeElement;
    box.hidden = false;
    document.documentElement.classList.add('szz-open');
    show(start);
    btnClose.focus();
  }

  function close() {
    if (!box || box.hidden) return;
    setFit();
    box.hidden = true;
    document.documentElement.classList.remove('szz-open');
    pic.removeAttribute('src');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function collect(root) {
    var imgs = Array.prototype.slice.call(root.querySelectorAll('[data-sa-slide] img.sa-media'));
    return imgs.map(function (img) {
      return { small: img.currentSrc || img.src, big: biggestSrc(img), alt: img.alt, el: img };
    });
  }

  // One listener for the whole document: works after theme-editor reloads too
  document.addEventListener('click', function (e) {
    var img = e.target.closest ? e.target.closest('.sa-page [data-sa-slide] img.sa-media') : null;
    if (!img) return;
    var root = img.closest('.sa-page');
    var images = collect(root);
    var start = 0;
    images.forEach(function (it, i) { if (it.el === img) start = i; });
    e.preventDefault();
    open(images, start);
  });

  // Keyboard users: Enter on the focused gallery opens the zoom
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var g = e.target.closest ? e.target.closest('.sa-page [data-sa-gallery]') : null;
    if (!g || e.target !== g) return;
    var root = g.closest('.sa-page');
    var active = root.querySelector('[data-sa-slide].is-active img.sa-media') || root.querySelector('[data-sa-slide] img.sa-media');
    if (!active) return;
    var images = collect(root);
    var start = 0;
    images.forEach(function (it, i) { if (it.el === active) start = i; });
    e.preventDefault();
    open(images, start);
  });

  window.addEventListener('resize', function () { if (box && !box.hidden && zoomed) setFit(); });
})();
